<template>
    <div class="the-detail-aside flex-grow-1 d-flex flex-column">
        <div class="search pt40 pl40 d-flex align-center justify-space-between">
            <isc-input
                v-model="keywords"
                placeholder="找文档"
                suffix-icon="isc-icon-search"
                suffix-icon-click
                class="search__input"
                clearable
                @icon-click="onSearch"
                @keydown.enter.native="onSearch"
            >
            </isc-input>
        </div>

        <div class="book-info d-flex align-center">
            <h1 class="title__main">{{productName}}</h1>
            <isc-select @change="versionChange" class="versions" v-model="currentVersion">
                <isc-option
                    v-for="version in versionList"
                    :key="version.value"
                    :value="version.value"
                    :label="version.label"
                ></isc-option>
            </isc-select>
        </div>

        <div class="menu flex-grow-1">
            <isc-scrollbar class="menu__body">
                <the-aside-menu :menu-list="categoryList" @change="onChange"></the-aside-menu>
            </isc-scrollbar>
        </div>
    </div>
</template>
<script>
import { queryCategoryByDocId, getProductInfolist } from '../../service';
import TheAsideMenu from './aside/the-aside-menu';
import { warning } from '../../../../utils/message';

export default {
    name: 'ThePathAside',

    components: { TheAsideMenu },

    props: {
        catalogId: {
            type: Number,
            default: -1
        }
    },

    data() {
        return {
            keywords: '',
            subTitle: '-',
            categoryList: [],
            showLine: true,
            showShelf: false,
            showShelfTimeId: 0,
            productName: '',
            productDocInfo: null,
            currentVersion: "",
            versionList: []
        };
    },

    computed: {
        docId() {
            return this.$route.query.bookId;
        },

        pageId() {
            return this.$route.query.pageId;
        }
    },

    watch: {
        docId: {
            immediate: true,
            handler() {
                this.initCatalog();
            }
        }
    },

    methods: {
        async initProductInfo() {
            const productDocInfoJson =  sessionStorage.getItem("productDocInfo");
            if (!productDocInfoJson) {
                await getProductInfolist();
            }
            this.productDocInfo = JSON.parse(sessionStorage.getItem("productDocInfo"))
        },

        versionChange(bookId) {
            console.log("当前选中book", bookId);
            // const query = {
            //     // pageId: '',
            //     bookId: bookId
            // };
            // let location = { name: '文档详情', query };
            // location.push
            // history.pushState(null, "", "/document/detail?bookId=2")
            // this.$router.push(location)
            // 找到对应版本的pageid
            // this.$router.push({ name: '文档详情', query: {pageId: 3, bookId}})
            // 未找到
            location.replace(`${location.origin}/document/detail?bookId=${bookId}`)
        },

        async initCatalog() {
            const { title, children } = await queryCategoryByDocId(this.docId);
            this.subTitle = title;
            this.categoryList = children;
            const bookInfo = title.split(" ");
            this.productName = title.replace(` ${bookInfo[bookInfo.length -1]}`, "");
            // console.log(this.productName)
            if (!this.productDocInfo) {
                await this.initProductInfo();
                this.productDocInfo[this.productName].forEach(item => {
                    this.versionList.push({label: item.name, value: item.id.toString()})
                });
                this.currentVersion = this.docId.toString();
            }
        },

        // onShowShelf() {
        //     clearTimeout(this.showShelfTimeId);
        //     this.showShelf = true;
        // },

        // onHideShelf() {
        //     clearTimeout(this.showShelfTimeId);
        //     this.showShelfTimeId = setTimeout(() => {
        //         this.showShelf = false;
        //     }, 234);
        // },

        onSearch() {
            const keywords = this.keywords.trim();
            const { docId, pageId } = this;

            if (keywords) {
                this.$router.push({
                    name: '文档搜索',
                    query: { bookId: docId, keywords }
                });
            } else {
                warning('请输入关键词之后再进行搜索', { title: '警告', type: 'warning' });
            }
        },

        onChange(pageId, first) {
            console.log("onChange", pageId, first);
            const query = {
                pageId,
                bookId: this.docId
            };
            let location = { name: '文档详情', query };

            if (this.pageId === pageId) return;

            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;

            if (first) {
                this.$router.replace(location);
            } else {
                this.$router.push(location);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~@isyscore/styles/variables';

.search {
    padding-right: 20px;
    position: relative;

    &__icon {
        width: 42px;
        height: 18px;
        cursor: pointer;

        &__inner {
            height: 3px;
            background: #999999;
            width: 100%;
            transition: width 0.3s;
        }

        &--active &__inner {
            background: $app-primary-color;
        }

        &--active &__inner:nth-child(2) {
            width: 50%;
        }
    }

    &__shelf {
        position: absolute;
        left: 100%;
        top: 0;
        z-index: 1;
        cursor: default;
    }
}

.fade {
    &-enter-active,
    &-leave-active {
        transition: opacity 0.3s;
    }

    &-enter,
    &-leave-to {
        opacity: 0;
    }

    &-enter-to,
    &-leave {
        opacity: 1;
    }
}

.title {
    padding: 0 40px;
    font-weight: 900;

    &__main {
        font-size: 16px;
    }

    &__sub {
        font-size: 22px;
    }
}
.book-info {
    padding: 0 20px 0 40px;
    margin: 20px 0;
    .versions {
        flex: 1;
    }
    .title__main {
        margin-right: 10px;
    }
}

.menu {
    position: relative;

    &__body {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
}
</style>
